<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h2 class="mb-0">{{ $t("firm.management") }}</h2>
    </div>
    <div class="d-flex  mt-4 justify-content-between">
      <div class="search2">
        <div class="search2--icon"><i class="iconoir-search"></i></div>
        <input v-model="nameFilter" class="search2--input" type="text" :placeholder="$t('common.search')" />
      </div>
    </div>
    <div class="row mt-4 align-items-end"></div>

    <div v-if="summaryDocs.length" class="table-responsive mt-4">
      <table class="table project-list-table compact">
        <thead>
          <tr>
            <th>{{ $t("common.name") }}</th>
            <th style="width: 160px">{{ $t("firm.status.text") }}</th>
            <th class="text-center">{{ $t("firm.support-service") }}</th>
            <th class="text-center">{{ $t("firm.virtual-server") }}</th>
            <th>{{ $t("firm.audit.audit-start") }}</th>
            <th>{{ $t("firm.test-approval-date") }}</th>
            <th>{{ $t("firm.prod-approval-date") }}</th>
            <th class="text-center">{{ $t("firm.audit.active-count") }}</th>
            <th class="text-center">{{ $t("firm.audit.completed-count") }}</th>
            <th>{{ $t("common.created-at") }}</th>
            <th style="width: 30px">
              <a href="javascript:;" @click="toggleFilter">
                <span v-if="filterEnabled" class="text-warning">
                  <i class="bx bxs-filter-alt"></i>
                  {{ $t("common.filters-hide") }}
                </span>
                <span v-else class="text-muted">
                  <i class="bx bxs-filter-alt"></i>
                  {{ $t("common.filters-show") }}
                </span>
              </a>
            </th>
          </tr>
          <tr v-if="filterEnabled">
            <th>
              <!-- <input class="form-control" v-model="nameFilter" :placeholder="$t('common.search')" /> -->
            </th>
            <th></th>
            <th class="text-center">
              <select class="form-control" v-model="supportServiceFilter">
                <option :value="undefined">{{ $t("common.all") }}</option>
                <option :value="true">{{ $t("common.yes") }}</option>
                <option :value="false">{{ $t("common.no") }}</option>
              </select>
            </th>
            <th class="text-center">
              <select class="form-control" v-model="virtualServerFilter">
                <option :value="undefined">{{ $t("common.all") }}</option>
                <option :value="true">{{ $t("common.yes") }}</option>
                <option :value="false">{{ $t("common.no") }}</option>
              </select>
            </th>
            <th colspan="7"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in summaryDocs" :key="item.firm._id">
            <td class="align-middle">
              <h6 class="mb-0 font-weight-bold">{{ item.firm.name | translate }}</h6>
            </td>
            <td class="align-middle">
              <firm-status-select :selected="getFirmStatusForItem(item)" @onSelect="(val) => onStatusSelect(val, item)" />
            </td>
            <td class="text-center align-middle">
              <i
                v-if="item.supportService !== null && item.supportService !== undefined ? item.supportService : item.firm.supportService"
                class="mdi mdi-check-circle text-success font-size-18"
              ></i>
              <i v-else class="mdi mdi-close-circle text-danger font-size-18"></i>
            </td>
            <td class="text-center align-middle">
              <i
                v-if="item.virtualServer !== null && item.virtualServer !== undefined ? item.virtualServer : item.firm.virtualServer"
                class="mdi mdi-check-circle text-success font-size-18"
              ></i>
              <i v-else class="mdi mdi-close-circle text-danger font-size-18"></i>
            </td>
            <td class="align-middle text-muted">{{ formatDate(item.auditStartedAt) }}</td>
            <td class="align-middle text-muted">{{ formatDate(item.testReadyAt || item.firm.testApprovedAt) }}</td>
            <td class="align-middle text-muted">{{ formatDate(item.prodReadyAt || item.firm.prodApprovedAt) }}</td>
            <td class="text-center align-middle">
              <span class="badge badge-soft-primary font-size-12">{{ formatNumber(item.activeAuditCount) }}</span>
            </td>
            <td class="text-center align-middle">
              <span class="badge badge-soft-success font-size-12">{{ formatNumber(item.completedAuditCount) }}</span>
            </td>
            <td class="align-middle text-muted">{{ formatDate(item.createdAt || item.firm.createdAt) }}</td>
            <td class="text-right align-middle">
              <b-button variant="outline-main" size="sm" @click="goToAuditManagement(item.firm)">
                {{ $t("firm.audit.management") }}
              </b-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <content-loading v-if="isSummaryLoading" />

    <empty v-if="!isSummaryLoading && (!summary || !summary.docs || !summary.docs.length)">
      <h5 class="text-center">{{ $t("common.empty") }}</h5>
    </empty>

    <div v-if="summary" class="row mb-5 pb-5">
      <div class="col">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination v-model="request.options.page" :total-rows="summary.totalDocs" :per-page="summary.limit" limit="10" size="sm"></b-pagination>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { getFirmStatus, getStatusFieldByProduct } from "@/helpers/filters";
import ContentLoading from "@c/content-loading.vue";
import Empty from "@c/empty.vue";
import FirmStatusSelect from "@cc/firm-status-select";

export default {
  components: { ContentLoading, Empty, FirmStatusSelect },
  data() {
    return {
      nameFilter: undefined,
      supportServiceFilter: undefined,
      virtualServerFilter: undefined,
      filterEnabled: false,
      request: {
        options: { page: 1, limit: 15, sort: { [`name.tr`]: "asc" } },
        query: {},
      },
    };
  },
  computed: {
    summary() {
      return this.$store.getters["organizationFirm/summaryPagination"];
    },
    summaryDocs() {
      return this.summary && this.summary.docs ? this.summary.docs : [];
    },
    isSummaryLoading() {
      return this.$store.getters["organizationFirm/isSummaryLoading"];
    },
    currentProduct() {
      return this.$store.getters["product/currentProduct"] || "FWSED";
    },
  },
  watch: {
    nameFilter(n, o) {
      if (n) {
        this.request.query = { ...this.request.query, name: { value: n } };
      } else {
        this.request.query["name"] = null;
        delete this.request.query["name"];
      }
    },
    supportServiceFilter(n, o) {
      if (n !== undefined) {
        this.request.query = { ...this.request.query, supportService: { value: n, isObject: true } };
      } else {
        this.request.query["supportService"] = null;
        delete this.request.query["supportService"];
      }
    },
    virtualServerFilter(n, o) {
      if (n !== undefined) {
        this.request.query = { ...this.request.query, virtualServer: { value: n, isObject: true } };
      } else {
        this.request.query["virtualServer"] = null;
        delete this.request.query["virtualServer"];
      }
    },
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.fetchSummary());
      },
    },
  },
  methods: {
    async onStatusSelect(event, item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return await this.fetchSummary();
      }

      try {
        // Dynamically determine status field based on product
        const statusField = getStatusFieldByProduct(this.currentProduct);
        const payload = {
          firmId: item?.firm?._id,
          [statusField]: event,
        };
        await this.$store.dispatch("organizationFirm/updateStatus", payload);
        await this.fetchSummary();
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    getFirmStatusForItem(item) {
      return getFirmStatus(item?.firm, this.currentProduct);
    },

    goToAuditManagement(firm) {
      this.$store.commit("organizationFirm/selectedEntity", firm);
      this.$router.push(`/fwsed/firm-management/${firm._id}/audit`);
    },

    async fetchSummary() {
      await this.$store.dispatch("organizationFirm/fetchSummary", this.request);
    },
    formatDate(value) {
      if (!value) return "-";
      return this.$options.filters.date(value, true);
    },
    formatBoolean(value) {
      return value ? this.$t("common.yes") : this.$t("common.no");
    },
    formatNumber(value) {
      if (value === null || value === undefined) return "-";
      const number = Number(value);
      if (Number.isNaN(number)) return "-";
      return number.toLocaleString("tr-TR");
    },
    toggleFilter() {
      this.filterEnabled = !this.filterEnabled;
      if (!this.filterEnabled) {
        this.nameFilter = undefined;
        this.supportServiceFilter = undefined;
        this.virtualServerFilter = undefined;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
tr {
  text-align: center;
}
td {
  text-align: center;
}
th {
  vertical-align: middle !important;
}

.badge-soft-primary {
  background-color: rgba(43, 85, 222, 0.1);
  color: #2b55de;
}

.badge-soft-success {
  background-color: rgba(52, 195, 143, 0.1);
  color: #34c38f;
}
</style>
